import { useSyncExternalStore } from "react";

/** One subscription to a CSS media query. `false` where `matchMedia` does not exist (SSR, old jsdom). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },
    () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  );
}

export const usePrefersReducedMotion = () => useMediaQuery("(prefers-reduced-motion: reduce)");

/** Light tap feedback through the native bridge (app-native). A no-op on the web. */
export function haptic(kind: "light" | "medium" | "success" = "light"): void {
  const bridge = (globalThis as { HelmrNative?: { haptic?: (k: string) => void } }).HelmrNative;
  try { bridge?.haptic?.(kind); } catch { /* the bridge is optional */ }
}
